﻿window.cObjetContactMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetTableUpdateLib = function () { return ["champ_table_nomprenom"] }

    var _lstChampTableData = null
    this.mGetLstChampTableData = function (funcOkAsync) {
        if (_lstChampTableData == null) {
            if (typeof objet.data == 'undefined' && objet.id == null) {
                //on est sur un element non sauvegardé
                _lstChampTableData = []
                if (typeof funcOkAsync != 'undefined') funcOkAsync(_lstChampTableData)
            } else {
                Me.objet.bddRef.mAjaxCall({
                    command: "getchamptabledata",
                    id_table: objet.mGetTable().id_table,
                    id: objet.id,
                    id_historique_sup: objet.id_historique_sup,
                    async: (typeof funcOkAsync != 'undefined')
                }, function (data) {
                    _lstChampTableData = ((typeof data.lstdata == 'undefined') ? [] : data.lstdata)
                    if (typeof funcOkAsync != 'undefined') funcOkAsync(_lstChampTableData)
                })
            }
        } else {
            if (typeof funcOkAsync != 'undefined') funcOkAsync(_lstChampTableData)
        }
        return _lstChampTableData
    }
    this.mSetLstChampTableData = function (lstChampTableData) {
        _lstChampTableData = lstChampTableData
    }

    this.mAddChampTableNomPrenom = function (nom) {
        _lstChampTableData = []
        var dataString = Me.objet.bddRef.getObjet("champ_table_nomprenom").mGetNewData()
        dataString.nom = nom
        dataString.id_champ_table = parametre.champ.id_champ_table_nomprenom
        _lstChampTableData.push(dataString)
    }

    this.mGetLibBase = function () { return "Contact"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau contact"; }
    this.mGetLib1 = function (option) {
        if (typeof option == 'undefined') option = {}
        if (typeof option.dataTemplate != 'undefined') {
            return mGetLib1(option.dataTemplate)
        } else {
            if (typeof objet.data == 'undefined') {
                if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack("") }
                else { return "" }
            } else {
                var txt = ""
                if (Me.objet.cle() == null) {
                    if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
                    else { return txt }
                } else {
                    Me.objet.bddRef.mAjaxCall({
                        command: "getlstdatavirtualgrid",
                        data: [{ id_table: Me.objet.mGetTable().id_table, id: Me.objet.cle() }],
                        async: (typeof option.callBack != 'undefined')
                    }, function (data) {
                        var dataTemplate = ((typeof data.lstdatatemplate == "undefined") ? null :  data.lstdatatemplate[0])
                        txt = ((dataTemplate == null) ? "" : mGetLib1(dataTemplate))
                    })
                    return txt
                }
            }
        }

        function mGetLib1(dataTemplate) {
            var txt = ""
            if ((dataTemplate.con_nom == null || dataTemplate.con_nom.length == 0) && (dataTemplate.con_prenom == null || dataTemplate.con_prenom.length == 0)) { txt = "" }
            else {
                var txt = "";
                if (dataTemplate.con_nom != null && dataTemplate.con_nom.length > 0) txt += dataTemplate.con_nom;
                if (dataTemplate.con_prenom != null && dataTemplate.con_prenom.length > 0) {
                    if (txt.length > 0) txt += " ";
                    txt += dataTemplate.con_prenom;
                }
            }
            if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
            else { return txt }
        }
        //var champTableNomPrenom = this.mGetLstChampTableData().filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_nomprenom })[0]
        //if (typeof champTableNomPrenom == 'undefined') { return "" }
        //else {
        //    var txt = ""
        //    if ((champTableNomPrenom.nom == null || champTableNomPrenom.nom.length == 0) && (champTableNomPrenom.prenom == null || champTableNomPrenom.prenom.length == 0)) { return "" }
        //    else {
        //        var txt = "";
        //        if (champTableNomPrenom.nom != null && champTableNomPrenom.nom.length > 0) txt += champTableNomPrenom.nom;
        //        if (champTableNomPrenom.prenom != null && champTableNomPrenom.prenom.length > 0) {
        //            if (txt.length > 0) txt += " ";
        //            txt += champTableNomPrenom.prenom;
        //        }
        //    }
        //    //var adrEmail = this.mGetAdresseEmailDefaut()
        //    //if (adrEmail.length > 0) txt += ((txt.length > 0) ? " &bull; " : "") + adrEmail
        //    return txt
        //}
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetNomFromTemplate = function (dataTemplate) {
        return this.mGetLibNomPrenomFromDataTemplate(dataTemplate)
    }
    this.mGetLibNomPrenomFromDataTemplate = function (dataTemplate) {
        var txt = ""
        if ((dataTemplate.con_nom == null || dataTemplate.con_nom.length == 0) && (dataTemplate.con_prenom == null || dataTemplate.con_prenom.length == 0)) { txt = "" }
        else {
            var txt = "";
            if (dataTemplate.con_nom != null && dataTemplate.con_nom.length > 0) txt += dataTemplate.con_nom.toUpperCase();
            if (dataTemplate.con_prenom != null && dataTemplate.con_prenom.length > 0) {
                if (txt.length > 0) txt += " ";
                txt += dataTemplate.con_prenom;
            }
        }
        return ((txt.length == 0) ? "(Pas de nom/prénom)" : txt)
    }

    this.mGetNom = function () {
        return this.mGetLib1()
        //var champTableNomPrenom = this.mGetLstChampTableData().filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_nomprenom })[0]
        //if (typeof champTableNomPrenom == 'undefined') { return "" }
        //else {
        //    if ((champTableNomPrenom.nom == null || champTableNomPrenom.nom.length == 0) && (champTableNomPrenom.prenom == null || champTableNomPrenom.prenom.length == 0)) { return "" }
        //    else {
        //        var txt = "";
        //        if (champTableNomPrenom.nom != null && champTableNomPrenom.nom.length > 0) txt += champTableNomPrenom.nom;
        //        if (champTableNomPrenom.prenom != null && champTableNomPrenom.prenom.length > 0) {
        //            if (txt.length > 0) txt += " ";
        //            txt += champTableNomPrenom.prenom;
        //        }
        //        return txt
        //    }
        //}
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        if (typeof objet.data == 'undefined') {
            //on est sur une nouvelle structure
        } else {
            txt = this.mGetLib1()
            //var champTableNomPrenom = this.mGetLstChampTableData().filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_nomprenom })[0]
            //if (typeof champTableNomPrenom != 'undefined') {
            //    if (typeof champTableNomPrenom.prenom != 'undefined' && champTableNomPrenom.prenom != null && champTableNomPrenom.prenom.length > 0 && typeof champTableNomPrenom.nom != 'undefined' && champTableNomPrenom.nom != null && champTableNomPrenom.nom.length > 0) {
            //        txt += champTableNomPrenom.prenom[0].toUpperCase();
            //        txt += champTableNomPrenom.nom[0].toUpperCase();
            //    }
            //    else {
            //        if ((typeof champTableNomPrenom.prenom == 'undefined' || champTableNomPrenom.prenom == null || champTableNomPrenom.prenom.length == 0) && (typeof champTableNomPrenom.nom == 'undefined' || champTableNomPrenom.nom == null || champTableNomPrenom.nom.length == 0)) { } else {
            //            if (typeof champTableNomPrenom.prenom != 'undefined' && champTableNomPrenom.prenom != null && champTableNomPrenom.prenom.length > 0) txt += champTableNomPrenom.prenom[0].toUpperCase() + ((champTableNomPrenom.prenom.length > 1) ? champTableNomPrenom.prenom[1].toUpperCase() : "");
            //            else { txt += champTableNomPrenom.nom[0].toUpperCase() + ((champTableNomPrenom.nom.length > 1) ? champTableNomPrenom.nom[1].toUpperCase() : ""); }
            //        }
            //    }
            //    if (txt.length == 0) {
            //        var champTableEmail = this.mGetLstChampTableData().filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_email })[0]
            //        if (typeof champTableEmail != 'undefined' && champTableEmail.valeur != 'undefined' && champTableEmail.valeur != null && champTableEmail.valeur.length > 0) txt = champTableEmail.valeur[0].toUpperCase() + ((champTableEmail.valeur.length > 1) ? champTableEmail.valeur[1].toUpperCase() : "");
            //    }
            //}
        }
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        var $Icone = null
        if (typeof dataTemplate == 'undefined') { $Icone = $("<i class='fas fa-portrait'></i>"); }
        else {
            $Icone = $("<i class='fas fa-portrait' style='position:relative'></i>");
        }
        if (typeof objet.data != 'undefined') {
            if (typeof objet.data.id_compte_client != 'undefined' && objet.data.id_compte_client != null) {
                $("<i class='fas fa-burst' style='position:absolute;top:-5px;right:-5px;color:red;font-size:65%;'></i>").appendTo($Icone)
            }
        } else if (typeof dataTemplate != 'undefined') {
            if (typeof dataTemplate.id_compte_client != 'undefined' && dataTemplate.id_compte_client != null) {
                $("<i class='fas fa-burst' style='position:absolute;top:-5px;right:-5px;color:red;font-size:65%;'></i>").appendTo($Icone)
            }
        }
        $Icone.attr("title", "Contact")
        return $Icone
    }

    this.mGetLstChampTable = function () {
        return Me.objet.bddRef.mGetArray("champ_table")
        //var lstChampOrder = []
        //Me.objet.bddRef.mGetArray("champ_table_config").filter(function (o) {
        //    return o.id_table == objet.mGetTable().id_table
        //}).sort(function (o1, o2) { return parseInt(o1.tri) - parseInt(o2.tri) }).forEach(function (champTableConfig) {
        //    var champTable = Me.objet.bddRef.mGetArray("champ_table").filter(function (o) { return o.id_champ_table == champTableConfig.id_champ_table })[0]
        //    if (champTable.id_champ_table != parametre.champ.id_champ_table_nomstructure) lstChampOrder.push(champTable)
        //})
        //return lstChampOrder
        ////return Me.objet.bddRef.mGetArray("champ_table").filter(function (o) {
        ////    return o.id_table == objet.mGetTable().id_table;
        ////}).sort(function (o1, o2) { return parseInt(o1.tri) - parseInt(o2.tri) })
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
    }

    this.mGetDataItemTemplate = function (funcOk) {
        this.mGetLstChampTableData(function (lstChampTableData) {
            var chData = new cTableChampData(Me.objet.bddRef, lstChampTableData)
            var adr = chData.mGetAdressePostaleDefaut()
            if (adr) {
                var obj = Me.objet.bddRef.getObjet(adr)
                adr = obj.objetMetier.mGetLibelleCourt()
            } else { adr = "" }
            var tel = ((objet.data.tel_sms == null) ? "" : objet.data.tel_sms)
            if (tel) {
                var obj = Me.objet.bddRef.getObjet(tel)
                tel = obj.objetMetier.mGetValueMiseEnForme()
            } else { tel = "" }
            var mobile = chData.mGetMobileDefaut()
            if (mobile) {
                var obj = Me.objet.bddRef.getObjet(mobile)
                mobile = obj.objetMetier.mGetValueMiseEnForme()
            } else { mobile = "" }
            var email = chData.mGetAdresseEmailDefaut()
            if (email) { email = email.valeur }
            else { email = "" }
            var site = chData.mGetSiteDefaut()
            if (site) { site = site.valeur }
            else { site = "" }
            funcOk({
                adr: adr,
                tel: tel,
                mobile: mobile,
                email: email,
                site: site
            })
        })
    }

    this.hasScrollPopup = function () { return false }
    //this.contentTemplatePopup = function (contentElement, option) {
    //    $("<div/>").appendTo(contentElement).dxCtrlPopupFicheContactEtActivite({
    //        bddCtrl: Me.objet.bddRef,
    //        id_table_destinataire: objet.mGetTable().id_table,
    //        id_destinataire: objet.cle(),
    //        onSelectionChanged: option.onSelectionChanged
    //    })
    //    //contentElement.closest(".dx-scrollable").css("padding", "3px 5px 0 10px")
    //    //contentElement.dxCtrlPopupContentStructuresContact({
    //    //    objet: objet,
    //    //    onDelete: function () {
    //    //        contentElement.closest(".dx-popup").dxPopup("instance").hide();
    //    //    }
    //    //})
    //}

    //this.contentTemplateSaisie = function (contentElement, option) {
    //    contentElement.empty();
    //    if (typeof option == 'undefined') option = {}
    //    opt = {
    //        bddCtrl: Me.objet.bddRef,
    //        id_table: objet.mGetTable().id_table,
    //        id: objet.data.id_contact,
    //        data: objet.data,
    //        objet: objet,
    //        onChange: option.onChange,
    //        onContentReady: option.onContentReady
    //    }
    //    opt.lstIdChampTableHide = []
    //    if (option.hideNom) opt.lstIdChampTableHide.push(parametre.champ.id_champ_table_nomprenom)
    //    if (option.hideDossier) opt.lstIdChampTableHide.push(parametre.champ.id_champ_table_dossier)
    //    if (option.showOnlyNom) opt.lstIdChampTableShow = [parametre.champ.id_champ_table_nomprenom]
    //    if (option.hideOrganiserFiche) opt.hideOrganiserFiche = option.hideOrganiserFiche
    //    var dxCtrlChampTable = $("<div style='padding:10px;'/>").appendTo(contentElement).dxCtrlChampTableData(opt).dxCtrlChampTableData("instance")
    //    return [dxCtrlChampTable]
    //}

    //this.mGetLstDataStructuresContact = function () {
    //    //return Me.objet.bddRef.lstIdStrCon.filter(function (o) { return o.idcon == objet.data.id_contact })
    //    return Me.objet.bddRef.mGetArray("structures_contact").filter(function (o) { return o.id_contact == objet.data.id_contact })
    //}

    this.mNbValue = function (withNom) {
        if (typeof withNom == 'undefined') withNom = false
        var nbValue = 0
        this.mGetLstChampTableData().forEach(function (champTableData) {
            if (withNom || (!withNom && champTableData.id_champ_table != parametre.champ.id_champ_table_nomprenom)) {
                if (Me.objet.bddRef.getObjet(champTableData).objetMetier.hasValue()) nbValue += 1
            }
            //if (!Me.objet.bddRef.getObjet(champTableData).objetMetier.hasValue() && (!withoutNom || champTableData.id_champ_table !=parametre.champ.id_champ_table_nomprenom)) {
            //    var typeChamp = new cTypeChamp(champTableData.id_champ_table)
            //    nbValue += ((typeChamp.objet().hasValue()) ? 1 : 0)
            //}
        })
        return nbValue
    }

    this.mGetWidthPopup = function () { return 750 }
    this.isPopupFullScreen = true
    //this.mShowPopup = function (option) {
    //    if (typeof option == 'undefined') option = {}
    //    if (typeof option.fullScreen == 'undefined') option.fullScreen = true
    //    page.mAddPopup(objet.data, option)
    //}
    this.contentTemplatePopup = function (contentElement, option) {
        $("<div/>").appendTo(contentElement).dxCtrlPopupFicheContactEtActivite({
            bddCtrl: Me.objet.bddRef,
            id_table_destinataire: objet.mGetTable().id_table,
            id_destinataire: objet.cle(),
            onSelectionChanged: option.onSelectionChanged,
            optionPopup: option,
            getUrl: function (funcOk) {
                objet.mGetDataTemplate([], function (dataTemplate) {
                    if (dataTemplate.site_web != null && dataTemplate.site_web.length > 0) { funcOk(dataTemplate.site_web) }
                    else { funcOk(objet.mGetLib1()) }
                })
            }
        })
    }

    this.mAddEventChangeLib = function (container, func) {
        Me.objet.bddRef.mAddFunctionOnModifiedItemData(["champ_table_nomprenom"], container,
            function (action, itemData) {
                if (typeof itemData != 'undefined' && itemData.id_table == Me.objet.bddRef.table.mGetIdTable("contact") && itemData.id == objet.cle()) {
                    if (itemData.id_champ_table == parametre.champ.id_champ_table_nomprenom) {
                        func()
                    }
                }
            })
    }

    //return le champValeur unitaire à partir d'un champTable
    this.mGetChampTableDataUnitaire = function (chpTableData) {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        return champTableData.mGetChampTableData(chpTableData)
    }
    //return la liste des champValeur à partir d'un champTable
    this.mGetLstChampTableDataUnitaire = function (chpTableData) {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        return champTableData.mGetLstChampTableData(chpTableData)
    }

    //return l'adresse postale au niveau du con
    this.mGetChampAdressePostaleDefautDirect = function () {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        var dataAdr = champTableData.mGetAdressePostaleDefaut()
        if (typeof dataAdr != 'undefined' && dataAdr != null) { return dataAdr }
        else { return null }
    }

    this.mGetChampAdressePostaleDefaut = function () {
        return this.mGetChampAdressePostaleDefautDirect()
    }

    this.mGetChampSiteDefaut = function () {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        var dataSiteWeb = champTableData.mGetSiteDefaut()
        if (typeof dataSiteWeb != 'undefined' && dataSiteWeb != null) { return dataSiteWeb }
        else { return null }
    }

    //return l'adresse email au niveau du con
    this.mGetChampAdresseEmailDefautDirect = function () {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        var dataAdrMail = champTableData.mGetAdresseEmailDefaut()
        if (typeof dataAdrMail != 'undefined' && dataAdrMail != null) { return dataAdrMail }
        else { return null }
    }

    this.mGetChampAdresseEmailDefaut = function () {
        return this.mGetChampAdresseEmailDefautDirect()
    }

    this.mGetAdresseEmailDefaut = function () {
        var champTableData = this.mGetChampAdresseEmailDefaut()
        if (champTableData != null) { return champTableData.valeur }
        else { return "" }
    }

    this.mAddAdresseEmailSiVide = function (adrEmail) {
        if (this.mGetAdresseEmailDefaut().length == 0) {
            //on a pas de mail
            debugger;
            var champTableEmail = Me.objet.bddRef.mGetArray("champ_table").filter(function (o) { return o.id_table == objet.mGetTable().id_table; }).filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_email })[0]
            var typeChamp = new cTypeChamp(champTableEmail.id_type_champ, Me.objet.bddRef)
            champDataEmail = typeChamp.mGetNewData(champTableEmail, objet.mGetTable().id_table, objet.cle())
            champDataEmail.valeur = adrEmail

            var tableChampDataEmail = new cTableChampData(Me.objet.bddRef)
            tableChampDataEmail.mSaveChampTableData("id_champ_table_email", champDataEmail, objet,
                function (obj) { obj.mSave() },
                null)
        }
    }

    //return le tel au niveau du con
    this.mGetChampTelDefautDirect = function () {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        var dataTelephone = champTableData.mGetTelephoneDefaut()
        if (typeof dataTelephone != 'undefined' && dataTelephone != null) { return dataTelephone }
        else { return null }
    }

    this.mGetChampTelDefaut = function () {
        return this.mGetChampTelDefautDirect()
    }

    this.mGetTelephoneDefaut = function () {
        var dataTelephone = this.mGetChampTelDefaut()
        if (typeof dataTelephone != 'undefined' && dataTelephone != null) { return Me.objet.bddRef.getObjet(dataTelephone).objetMetier.mGetValueMiseEnForme() }
        else { return "" }
    }

    //return le mobile au niveau du con
    this.mGetChampMobileDefautDirect = function () {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        var dataTelephone = champTableData.mGetMobileDefaut()
        if (typeof dataTelephone != 'undefined' && dataTelephone != null) { return dataTelephone }
        else { return null }
    }

    this.mGetChampMobileDefaut = function () {
        return this.mGetChampMobileDefautDirect()
    }

    this.mGetMobileDefaut = function () {
        var dataTelephone = this.mGetChampMobileDefaut()
        if (typeof dataTelephone != 'undefined' && dataTelephone != null) { return Me.objet.bddRef.getObjet(dataTelephone).objetMetier.mGetValueMiseEnForme() }
        else { return "" }
    }

    this.mAddTelMobileSiVide = function (dataTel) {
        if (this.mGetMobileDefaut().length == 0 && dataTel != null && dataTel.tel_number.length > 0) {
            //on a pas de mobile
            var champTableMobile = Me.objet.bddRef.mGetArray("champ_table").filter(function (o) { return o.id_table == objet.mGetTable().id_table; }).filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_mobile })[0]
            var typeChamp = new cTypeChamp(champTableMobile.id_type_champ, Me.objet.bddRef)
            champDataMobile = typeChamp.mGetNewData(champTableMobile, objet.mGetTable().id_table, objet.cle())

            champDataMobile.tel_code_pays = dataTel.tel_code_pays
            champDataMobile.tel_number = dataTel.tel_number
            champDataMobile.tel_complet = dataTel.tel_complet
            champDataMobile.telb_sms = dataTel.tel_sms
            champDataMobile.tel_error = dataTel.tel_error
            champDataMobile.tel_num_type = dataTel.tel_num_type

            var tableChampData = new cTableChampData(Me.objet.bddRef)
            tableChampData.mSaveChampTableData("id_champ_table_mobile", champDataMobile, objet,
                function (obj) { obj.mSave() },
                null)
        }
    }

    this.mShowNewContact = function () {
        page.mAddPopup(Me.objet.mGetNewData(), {
            fullScreen: true,
            nomTable: "structures",
            funcCreate: function (funcOk) {
                var obj = Me.objet.bddRef.getObjet(Me.objet.bddRef.getObjet("contact").mGetNewData())
                obj.data.temporaire = 1
                obj.mSave(function () {
                    funcOk(obj.data)
                })
            }
        })
        //var obj = Me.objet.bddRef.getObjet(Me.objet.bddRef.getObjet("contact").mGetNewData())
        //obj.data.temporaire = 1
        //obj.mSave(function () {
        //    obj.mShowPopup()
        //})
    }

    //this.mShowGridAndSelectContact = function (option, funcOk) {
    //    var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
    //        position: {
    //            my: "right top",
    //            at: "right top",
    //            of: "body"
    //        },
    //        width: 650,
    //        height: "100%",
    //        showTitle: true,
    //        showMaximize: true,
    //        title: ((typeof option.title == 'undefined') ? "Sélectionnez un contact" : option.title),
    //        contentTemplate: function (contentElement) {
    //            contentElement.css("padding-top","0")
    //            $("<div/>").appendTo(contentElement).dxCtrlGridStrCon({
    //                bddCtrl: Me.objet.bddRef,
    //                context_grid: "gridstrconaddcontactexistant",
    //                lstTypeGrille: ["Lignes", "Détails"],
    //                lstConditionBase: [{ nom_champ: "id_table_element", ope: "parmi", valeur: [{ value: Me.objet.bddRef.table.mGetItemFromNom("structures_contact").id_table }, { value: Me.objet.bddRef.table.mGetItemFromNom("contact").id_table }] }],
    //                onClickDataGrid: function (container, dataGrid, dataTemplate) {
    //                    var table = Me.objet.bddRef.table.mGetItem(dataGrid.id_table)
    //                    var obj = Me.objet.bddRef.getObjet(table.nom, dataGrid.id)
    //                    var data = null
    //                    if (obj.mGetTable().nom == "structures_contact") {
    //                        data = obj.objetMetier.mGetDataContact()
    //                    } else { data = obj.data }
    //                    popup.hide()
    //                    funcOk(data)
    //                },
    //                lstTypeGrille:["Détails","Lignes"],
    //                onEndClickDataGrid: function (dataGrid) { popup.hide(); },
    //                allowCheck: false,
    //                allowCarto: false,
    //                allowFilter: false,
    //                allowToolbar: true,
    //                allowGroup: false,
    //                showBtNew: false,
    //                showColumnHeaders: false
    //            })
    //            //Me.objet.bddRef.getObjet("structures_contact").contentTemplateGrid(contentElement, {
    //            //    filter_elements: ["contact", "structures_contact"],
    //            //    context_grid: "select_contact",
    //            //    allowCheck: false,
    //            //    showNewBt: false,
    //            //    showPlusBt: false,
    //            //    onClickItem: function (data) {
    //            //        var table = Me.objet.bddRef.table.mGetItem(data.id_table)
    //            //        var obj = Me.objet.bddRef.getObjet(table.nom, data.id)
    //            //        if (obj.mGetTable().nom == "structures_contact") {
    //            //            data = obj.objetMetier.mGetDataContact()
    //            //        } else { data = obj.data }
    //            //        popup.hide()
    //            //        funcOk(data)
    //            //    }
    //            //});
    //        }
    //    }).dxCtrlPopupBase("instance")
    //    popup.show();
    //}

    this.mCreateContact = function (value, funcOk) {
        //value = idTitre,nom,prenom,adresseEmail,adressePostal,telFixe,telMobile
        var dataContact = Me.objet.bddRef.getObjet("contact").mGetNewData()

        var lstChampTableData = []
        var lstChampTable = Me.objet.bddRef.mGetArray("champ_table")//.filter(function (chp) {
        //    return Me.objet.bddRef.mGetArray("champ_table_config").filter(function (chpConf) {
        //        return chp.id_champ_table == chpConf.id_champ_table && chpConf.id_table == objet.mGetTable().id_table;
        //    }).length > 0
        //})

        if (typeof value.nom_prenom != 'undefined' && value.nom_prenom != null) {
            //nom/prénom
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_nomprenom })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableData = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableData.nom_table_champ_table = "champ_table_nomprenom"
            champTableData.nom = value.nom_prenom.nom
            champTableData.prenom = value.nom_prenom.prenom
            champTableData.id_titre = value.nom_prenom.id_titre
            lstChampTableData.push(champTableData)
        }
        if (typeof value.adresse_email != 'undefined' && value.adresse_email != null) {
            //adresse email
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_email })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableData = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableData.nom_table_champ_table = "champ_table_email"
            champTableData.valeur = value.adresse_email
            lstChampTableData.push(champTableData)
        }
        if (typeof value.adresse_postale != 'undefined' && value.adresse_postale != null) {
            //adresse postale
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_adr })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableData = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableData.nom_table_champ_table = "champ_table_adresse"
            champTableData.ad1 = value.adresse_postale.ad1
            champTableData.ad2 = value.adresse_postale.ad2
            champTableData.ad3 = value.adresse_postale.ad3
            champTableData.cp = value.adresse_postale.cp
            champTableData.ville = value.adresse_postale.ville
            champTableData.cedex = value.adresse_postale.cedex
            champTableData.dpt = value.adresse_postale.dpt
            champTableData.region = value.adresse_postale.region
            champTableData.pays = value.adresse_postale.pays
            champTableData.geo_latitude = value.adresse_postale.geo_latitude
            champTableData.geo_longitude = value.adresse_postale.geo_longitude
            champTableData.code_pays = value.adresse_postale.code_pays
            lstChampTableData.push(champTableData)
        }
        if (typeof value.tel != 'undefined' && value.tel != null && value.tel.tel_sms.length > 0) {
            //téléphone fixe
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_tel })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableData = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableData.nom_table_champ_table = "champ_table_tel"
            var tel = new cTelephone(value.tel.tel_code_pays, value.tel.tel_sms)
            var dataTel = tel.mGetTelephoneDetail()
            champTableData.tel_sms = dataTel.tel_sms
            champTableData.tel_code_pays = dataTel.tel_code_pays
            champTableData.tel_number = dataTel.tel_number
            champTableData.tel_complet = dataTel.tel_code_pays
            champTableData.tel_error = "0"
            champTableData.tel_num_type = "1"
            lstChampTableData.push(champTableData)
        }
        if (typeof value.mobile != 'undefined' && value.mobile != null && value.mobile.tel_sms.length > 0) {
            //téléphone mobile
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_mobile })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableData = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableData.nom_table_champ_table = "champ_table_tel"
            var tel = new cTelephone(value.mobile.tel_code_pays, value.mobile.tel_sms)
            var dataTel = tel.mGetTelephoneDetail()
            champTableData.tel_sms = dataTel.tel_sms
            champTableData.tel_code_pays = dataTel.tel_code_pays
            champTableData.tel_number = dataTel.tel_number
            champTableData.tel_complet = dataTel.tel_code_pays
            champTableData.tel_error = "0"
            champTableData.tel_num_type = "0"
            lstChampTableData.push(champTableData)
        }

        dataContact.id_utilisateur = Me.objet.bddRef.utiCourant.id_utilisateur

        Me.objet.bddRef.mAjaxCall({ command: "create_contact_with_data", data: dataContact, lst_champ_table_data: lstChampTableData, async: value.async }, function (data) {
            dataContact.id_contact = data.id
            funcOk(dataContact)
        })
    }

    this.mSaveClientExterne = function (clientExterne, funcOk) {
        var objets = Me.objet.bddRef.getObjets()
        var lstChampTable = Me.objet.bddRef.mGetArray("champ_table").filter(function (o) { return o.id_table == objet.mGetTable().id_table; })

        var champTableDataNomPrenom = this.mGetLstChampTableData().filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_nomprenom })[0]
        if (typeof champTableDataNomPrenom == "undefined") {
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_nomprenom })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableDataNomPrenom = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableDataNomPrenom.id_table = objet.mGetTable().id_table
            champTableDataNomPrenom.id = objet.data.id_contact
        }
        champTableDataNomPrenom.nom = clientExterne.nom
        champTableDataNomPrenom.prenom = clientExterne.prenom
        champTableDataNomPrenom.id_titre = clientExterne.id_titre
        objets.mAddData([champTableDataNomPrenom], "save")

        var champTableDataEmail = this.mGetLstChampTableData().filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_email })[0]
        if (typeof champTableDataEmail == "undefined") {
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_email })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableDataEmail = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableDataEmail.id_table = objet.mGetTable().id_table
            champTableDataEmail.id = objet.data.id_contact
        }
        champTableDataEmail.valeur = clientExterne.adresse_email
        objets.mAddData([champTableDataEmail], "save")

        var champTableDatadrPostale = this.mGetLstChampTableData().filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_adr })[0]
        if (typeof champTableDatadrPostale == "undefined") {
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_adr })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableDatadrPostale = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableDatadrPostale.id_table = objet.mGetTable().id_table
            champTableDatadrPostale.id = objet.data.id_contact
        }
        champTableDatadrPostale.code_pays = clientExterne.code_pays
        champTableDatadrPostale.pays = clientExterne.pays
        objets.mAddData([champTableDatadrPostale], "save")

        var champTableDataTelMobile = this.mGetLstChampTableData().filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_mobile })[0]
        if (typeof champTableDataTelMobile == "undefined") {
            champTableDataTelMobile = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_mobile })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableDataTelMobile = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableDataTelMobile.id_table = objet.mGetTable().id_table
            champTableDataTelMobile.id = objet.data.id_contact
        }
        champTableDataTelMobile.code_pays = clientExterne.mob_code_pays
        champTableDataTelMobile.valeur = clientExterne.mob_valeur
        objets.mAddData([champTableDataTelMobile], "save")

        objets.mAddData([clientExterne], "save")
        objets.mSave(function () {
            if (typeof funcOk != 'undefined') funcOk(clientExterne)
        })
    }

    this.mGetPopupPositionWidthHeight = function () {
        return {
            width: "700",
            maxWidth: "calc(100% - 60px)",
            height: "calc(100% - 90px)",
            maxHeight: "calc(100% - 50px)",
            position: {
                my: "right top",
                at: "right top",
                of: "body",
                offset: { x: -30, y: 65 }
            }
        }
    }

    this.mPrint = function () {
        jaugeDemarrage.mShow()
        objet.bddRef.mAjaxCall({
            command: "printstrcon",
            id_table: objet.mGetTable().id_table,
            id: objet.cle()
        }, function (data) {
            if (data.urlpdf) {
                if (data.urlpdf.startsWith("~")) data.urlpdf = data.urlpdf.substring(1)
                $("<div/>").dxCtrlPdfViewer({
                    urlPdf: data.urlpdf,
                    allowClose: true,
                    padding: "0px"
                })
                jaugeDemarrage.mHide()
            }
        })
    }

}